/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import { MARGIN_ERROR_FIELDS, SVG_ICONS } from '../../../constants';

const MarginModalLeftSection = ({
  marketMargins, handleFromChange, getToOddValue, handleMarginChange, removeMargin,
  errorType, errorRow,
}) => (

  <div className="dialog__wrapper dialog__wrapper--sm">
    {marketMargins?.map((marketMargin, idx) => (
      <div
        className={`dialog__row d-flex align-items-center ${idx !== 0 && 'm-t-10'}`}
        key={`marketMargins-row-${idx}`}
      >
        <span>{`(${idx + 1})`}</span>
        <span className="dialog__row-txt m-r-15 m-l-10">From</span>
        <div className="dialog__input-wrap m-r-15">
          <input
            className={`dialog__input text-center ${errorType === MARGIN_ERROR_FIELDS.FROM_ODDS
              && errorRow === idx + 1 ? 'dialog__input--error' : ''}`}
            type="number"
            step="0.01"
            min="1"
            max="1000"
            onChange={(e) => handleFromChange(e, idx)}
            value={marketMargins[idx]?.fromOdds?.toFixed(2)}
            disabled={idx === 0}
          />
        </div>
        <span className="dialog__row-txt">To</span>
        <div className="dialog__input-wrap m-r-15 dialog__input-wrap--disabled">
          <input
            className="dialog__input text-center"
            type="number"
            step="0.01"
            min="1"
            max="1000"
            disabled
            value={getToOddValue(idx)}
          />
        </div>
        <span className="m-r-15">=</span>
        <div className="dialog__input-wrap">
          <input
            className={`dialog__input text-center ${errorType === MARGIN_ERROR_FIELDS.MARGINS
              && errorRow === idx + 1 ? 'dialog__input--error' : ''}`}
            type="number"
            step="0.01"
            min="1"
            max="2"
            onChange={(e) => handleMarginChange(e, idx)}
            value={marketMargins[idx]?.margin?.toFixed(2)}
          />
          {(idx !== 0 && idx === marketMargins?.length - 1) && (
            <div
              className="dialog__delete-icon"
              onClick={removeMargin}
            >
              <SVGComponent
                className="dialog__delete-bin"
                src={`${SVG_ICONS.utility}#bin`}
              />
            </div>
          )}
        </div>
      </div>
    ))}

  </div>
);

export default MarginModalLeftSection;
